module.exports = __webpack_public_path__ + "img/booking_types.9ecd48f3.svg";